import React, { useState, useEffect, useCallback  } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import { IntlGetText } from "util/IntlMessages";
import InfoCard from "components/InfoCard";
import QarzibaDialog from "./Dialog";
import { callActionApi, getQarzibaInfo } from "api/apiList";
import { callStartImpact } from "actions/Impact";

const Qarziba = () => {
    const dispatch = useDispatch();
  const readOnlyImpactView = useImpactReadOnly();
    const { selectedPrescription } = useSelector(({ management }) => management);
    const { impactStartDate, consentSigned, isCIRequired } =
        useSelector(({ impact }) => impact);

    const [open, setOpen] = useState(false);
    const [qarzibaInfo, setQarzibaInfo] = useState([]);

    const msgConsentRequired = IntlGetText("impact.consentRequired");

    const handleClickOpen = () => {
        if (openImpactBoxIfReadOnly(readOnlyImpactView, () => setOpen(true))) return;
        if (!impactStartDate) {
            dispatch(callStartImpact(true));
            return;
        }
        if (isCIRequired && !consentSigned) {
            NotificationManager.warning(msgConsentRequired);
            return;
        }
        setOpen(true);
    };

    const callApi = (apiFunc, setData) => {
        callActionApi(
            apiFunc,
            setData,
            (error) => {
                if (typeof error === "string") NotificationManager.error(error);
            }
        );
    };

    const loadQarziba = () => {
        callApi(
            () => getQarzibaInfo(selectedPrescription.id),
            (data) => {
                setQarzibaInfo(data);
            }
        );
    };

  const handleRequestClose = () => setOpen(false);
    
    return (
        <div>
            <InfoCard
                data={{
                    icon: "hospital",
                    title: IntlGetText("core.vital.not.available"),
                    subTitle: IntlGetText("ledaga.cardSubTitle"),
                    color: "#757575",
                }}
                onClickBox={handleClickOpen}
            />
            <QarzibaDialog
                open={open}
                handleRequestClose={handleRequestClose}
                loadQarziba={loadQarziba}
                disableBackdropClick={true}
                qarzibaInfo={qarzibaInfo}
            />
        </div>
    );
};

export default Qarziba;
